import axios from "@/plugins/axios";

export default {
    listWhatsAppSenders(active = true) {
        let params = {}
        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/whatsapp_senders", { params });
    },

    updateWhatsappSender(id, payload) {
        return axios.httpApi.patch(`whatsapp_senders/${id}`, payload);
    },

    deleteWhatsappSender(id) {
        return axios.httpApi.delete(`whatsapp_senders/${id}`);
    },

    createWhatsappSender(payload) {
        return axios.httpApi.post(`whatsapp_senders`, payload);
    }
};